import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getSecurityRoles = (org_id?: number) => {
  let theQuery = '';
  if (org_id) {
    theQuery = `org_id=${org_id}`;
  }
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `department/security-role?` + theQuery
  );
};
export const AddSecurityRoles = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/security-role/create`,
    obj,
    { headers }
  );
};

export const EditSecurityRoles = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/security-role/update`,
    obj,
    { headers }
  );
};
export const DeleteSecurityRoles = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/security-role/delete`,
    obj,
    { headers }
  );
};
